import { createFileRoute } from "@tanstack/react-router";
import { LiveMimic } from "@/features/harvest-analysis/live-mimic";
import { JournalPage } from "@/features/harvest-journal/components/journal-page";

// Hidden from the sidebar for now — needs more work — but still reachable by
// address, and still wired.
export const Route = createFileRoute("/harvests/$session_id/live")({
  component: RouteComponent,
});

function RouteComponent() {
  const { session_id } = Route.useParams();
  return (
    <JournalPage>
      <LiveMimic sessionId={session_id} />
    </JournalPage>
  );
}
